module.exports = __webpack_public_path__ + "img/Compact-SR_Overview-DB_1.4a863b9e.jpg";